import http from "../http-common";

class fileUploadLogService {

  create(data) {
    return http.post("/fileuploadlog/bysuppliercode", data);
  }

  getAll() {
    return http.get("/fileuploadlog");
  }

  get(id) {
    return http.get(`/fileuploadlog/${id}`);
  }

  getBySuppliercode(id) {
    return http.get(`/fileuploadlog/bysuppliercode/${id}`);
  }
}

export default new fileUploadLogService();
